import React from 'react'
import useCodeInput from '../../../../common/hooks/useEmailCode/useEmailCode/hooks/useCodeInput'

interface CodeInputProps {
    value: string
    length: number
    onChange: (code: string) => void
    onSubmit: (code: string) => void
}

export const CodeInput = ({
    value,
    length,
    onChange,
    onSubmit,
}: CodeInputProps) => {
    const {
        inputsInOrder,
        onKeyDownInput,
        onChangeInput,
        onInputPaste,
        emptyDigit,
    } = useCodeInput({
        value,
        onSubmit,
        onChange,
        length,
    })
    const centerIdx = Math.floor(inputsInOrder.length / 2) - 1

    const getInputValue = (v: string) => {
        if (!v || v === emptyDigit) {
            return ''
        }
        return v
    }
    return (
        <div className="sm flex gap-1">
            {new Array(inputsInOrder.length).fill('').map((_, idx) => (
                <React.Fragment key={idx}>
                    <input
                        type="number"
                        pattern="\d*"
                        inputMode="numeric"
                        value={getInputValue(value[idx])}
                        onChange={onChangeInput(idx)}
                        onPaste={onInputPaste()}
                        onKeyDown={(e) => onKeyDownInput({e, idx})}
                        ref={inputsInOrder[idx]}
                        className="h-28 w-20 rounded-xl border-4 border-yellow-30 bg-cream-10 p-5 text-6xl"
                    />
                    {idx === centerIdx ? (
                        <div className="h-1 w-4 self-center bg-yellow-30" />
                    ) : null}
                </React.Fragment>
            ))}
        </div>
    )
}

export default CodeInput
